import icon from './icon';
import { jsx as _jsx } from "react/jsx-runtime";
const Icon = icon("0 0 20 17", "Collapse Horizontal", /*#__PURE__*/_jsx("path", {
  d: "M18.5 8h-5.293l2.364-2.364-.707-.707L11.293 8.5l3.571 3.571.707-.707L13.207 9H18.5V8zM4.429 5.636 6.793 8H1.5v1h5.293l-2.364 2.364.707.707L8.707 8.5 5.136 4.929l-.707.707zM9.5 2.259h1v2h-1zM9.5 5.827h1v2h-1zM9.5 9.248h1v2h-1zM9.5 12.742h1v2h-1z"
}));
if (process.env.NODE_ENV !== 'production') Icon.displayName = "IconCollapseHorizontal";
export default Icon;